import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import SalesManageStaticsContainer from '../../containers/sales-manage-statics/SalesManageStaticsContainer';

const SalesManageViewPage = () => {
  return (
    <>
      <BreadcrumbsContainer
        title="결산관리/판매관리비 통계"
        icon="statistics"
      />
      <SalesManageStaticsContainer />
    </>
  );
};

export default SalesManageViewPage;
